<template>
  <div class="linktree">
    <div class="bg-pattern"></div>

    <nav class="top-nav">
      <a
        v-if="logo && logo.url"
        :href="logo.url"
        target="_blank"
        rel="noopener noreferrer"
        class="nav-logo-link"
      >
        <img :src="logo.image_url" :alt="siteName" class="nav-logo" />
      </a>
      <span v-else class="nav-brand">{{ siteName }}</span>

      <a
        v-if="logo && logo.url"
        :href="logo.url"
        target="_blank"
        rel="noopener noreferrer"
        class="nav-cta"
      >
        Hemen Gir
      </a>
    </nav>

    <div v-if="loading" class="state-box">
      <div class="loader"></div>
      <p>Yükleniyor...</p>
    </div>

    <div v-else-if="error" class="state-box">
      <p class="error-text">{{ error }}</p>
      <button class="retry-btn" @click="loadData">Tekrar Dene</button>
    </div>

    <template v-else>
      <main class="container">
        <section class="social-section">
          <div class="section-heading">
            <div class="section-title-deco">
              <span class="section-ornament">✦</span>
            </div>
            <h2 class="section-title">
              Güncel iletişim<br />
              <em>kaynaklarımız</em>
            </h2>
            <div class="section-title-deco">
              <span class="section-ornament">✦</span>
            </div>
          </div>
          <div class="social-grid">
            <a
              v-for="link in socialLinks"
              :key="link.id"
              :href="link.url"
              target="_blank"
              rel="noopener noreferrer"
              class="social-btn"
            >
              <span class="btn-icon">
                <i :class="link.icon"></i>
              </span>
              <span class="btn-content">
                <span class="btn-name">{{ link.name }}</span>
                <span class="btn-label">{{ link.button_label }}</span>
              </span>
              <span class="btn-arrow">
                <i class="fas fa-chevron-right"></i>
              </span>
            </a>
          </div>
        </section>
      </main>

      <footer v-if="license" class="footer">
        <img
          :src="license.image_url"
          alt="Lisans"
          class="license-img"
        />
      </footer>
    </template>
  </div>
</template>

<script>
import { fetchSiteData } from './services/api'

export default {
  name: 'App',
  data() {
    return {
      loading: true,
      error: null,
      logo: null,
      license: null,
      socialLinks: [],
      siteName: 'WBahis'
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      this.error = null
      try {
        const data = await fetchSiteData()
        this.logo = data.logo
        this.license = data.license
        this.socialLinks = [...data.social_links].sort(
          (a, b) => a.sort_order - b.sort_order
        )
      } catch (e) {
        this.error = e.message || 'Bir hata oluştu'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  -webkit-tap-highlight-color: transparent;
}

body {
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
  background: #0a0806;
  color: #f5e6c8;
  min-height: 100vh;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
}
</style>

<style scoped>
.linktree {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 88px 16px 28px;
}

.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 64px;
  max-width: 100%;
  padding: 12px 16px;
  background: rgba(10, 8, 6, 0.92);
  border-bottom: 1px solid rgba(212, 175, 55, 0.25);
  backdrop-filter: blur(12px);
}

.nav-logo-link {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 124px);
  height: 40px;
  transition: transform 0.3s ease, filter 0.3s ease;
}

.nav-logo-link:hover {
  transform: scale(1.02);
  filter: drop-shadow(0 0 12px rgba(212, 175, 55, 0.35));
}

.nav-logo {
  display: block;
  width: auto;
  height: auto;
  max-height: 40px;
  max-width: 100%;
  object-fit: contain;
  object-position: left center;
}

.nav-brand {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  min-height: 40px;
  font-size: 16px;
  font-weight: 700;
  color: #d4af37;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.nav-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 40px;
  padding: 10px 18px;
  background: linear-gradient(135deg, #d4af37 0%, #b8860b 100%);
  border: 1px solid rgba(255, 215, 0, 0.35);
  border-radius: 999px;
  color: #0a0806;
  font-size: 14px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.25s ease;
  box-shadow: 0 4px 16px rgba(212, 175, 55, 0.2);
}

.nav-cta:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.35);
  filter: brightness(1.05);
}

.bg-pattern {
  position: fixed;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(212, 175, 55, 0.12) 0%, transparent 60%),
    radial-gradient(ellipse 60% 40% at 80% 100%, rgba(184, 134, 11, 0.08) 0%, transparent 50%),
    linear-gradient(180deg, #0d0b08 0%, #0a0806 50%, #110e09 100%);
  z-index: 0;
}

.bg-pattern::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d4af37' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.6;
}

.container {
  position: relative;
  z-index: 1;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
}

.state-box {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  color: #c9a84c;
}

.loader {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(212, 175, 55, 0.2);
  border-top-color: #d4af37;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error-text {
  color: #e8c468;
  font-size: 15px;
}

.retry-btn {
  padding: 10px 24px;
  background: transparent;
  border: 1px solid #d4af37;
  color: #d4af37;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.25s ease;
}

.retry-btn:hover {
  background: rgba(212, 175, 55, 0.15);
}

.social-section {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-bottom: 4px;
}

.section-title-deco {
  display: flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 360px);
}

.section-title-deco::before,
.section-title-deco::after {
  content: '';
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(212, 175, 55, 0.15), #d4af37, rgba(212, 175, 55, 0.15), transparent);
}

.section-ornament {
  padding: 0 14px;
  font-size: 12px;
  color: #d4af37;
  text-shadow: 0 0 12px rgba(212, 175, 55, 0.45);
}

.section-title {
  font-family: 'Cinzel', 'Georgia', serif;
  font-size: clamp(24px, 6vw, 36px);
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  letter-spacing: 0.6px;
  background: linear-gradient(135deg, #fff4d6 0%, #e8c468 28%, #d4af37 52%, #f5e6c8 72%, #b8860b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  filter: drop-shadow(0 2px 10px rgba(212, 175, 55, 0.22));
}

.section-title em {
  font-family: 'Cormorant Garamond', 'Georgia', serif;
  font-style: italic;
  font-weight: 600;
  font-size: 1.08em;
  letter-spacing: 1px;
  background: linear-gradient(135deg, #f5e6c8 0%, #d4af37 50%, #e8c468 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.social-grid {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.social-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
  width: 100%;
  max-width: 420px;
  padding: 14px 18px;
  background: linear-gradient(135deg, rgba(30, 24, 14, 0.9) 0%, rgba(20, 16, 10, 0.95) 100%);
  border: 1px solid rgba(212, 175, 55, 0.35);
  border-radius: 12px;
  text-decoration: none;
  color: #f5e6c8;
  text-align: left;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.social-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(212, 175, 55, 0.08) 0%, transparent 60%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.social-btn:hover {
  border-color: #d4af37;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(212, 175, 55, 0.15), inset 0 1px 0 rgba(255, 215, 0, 0.1);
}

.social-btn:hover::before {
  opacity: 1;
}

.btn-icon {
  width: 58px;
  height: 58px;
  min-width: 58px;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  font-size: 28px;
  flex-shrink: 0;
}

.btn-icon i {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  line-height: 1;
}

.btn-icon .fa-x-twitter {
  color: #ffffff;
}

.btn-icon .fa-telegram {
  color: #26a5e4;
}

.btn-icon .fa-instagram {
  background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.btn-icon .fa-whatsapp {
  color: #25d366;
}

.btn-icon .fa-phone {
  color: #4caf50;
}

.btn-icon .fa-video {
  color: #ff4444;
}

.btn-icon .fa-mobile-screen {
  color: #5ac8fa;
}

.btn-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  gap: 2px;
  text-align: left;
}

.btn-name {
  font-size: 15px;
  font-weight: 600;
  color: #f5e6c8;
}

.btn-label {
  font-size: 12px;
  color: #a89050;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-arrow {
  display: none;
  color: rgba(212, 175, 55, 0.5);
  font-size: 12px;
  transition: transform 0.3s ease, color 0.3s ease;
}

.social-btn:hover .btn-arrow {
  color: #d4af37;
  transform: translateX(3px);
}

.footer {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 480px;
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid rgba(212, 175, 55, 0.2);
  text-align: center;
}

.license-img {
  display: block;
  max-width: 160px;
  width: 100%;
  height: auto;
  margin: 0 auto;
  opacity: 0.85;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));
}

@media (min-width: 768px) {
  .linktree {
    padding: 96px 32px 36px;
  }

  .top-nav {
    padding: 16px 32px;
  }

  .nav-logo {
    max-height: 46px;
  }

  .nav-cta {
    padding: 11px 24px;
    font-size: 15px;
  }

  .container {
    max-width: 820px;
  }

  .section-title {
    font-size: clamp(28px, 4vw, 40px);
    letter-spacing: 0.8px;
  }

  .section-heading {
    gap: 12px;
    margin-bottom: 8px;
  }

  .section-title-deco {
    max-width: 480px;
  }

  .social-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    justify-items: center;
    gap: 16px;
    max-width: 100%;
  }

  .social-btn {
    max-width: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    aspect-ratio: 1;
    padding: 16px 12px;
    gap: 14px;
  }

  .btn-icon {
    width: auto;
    height: auto;
    min-width: 80px;
    min-height: 80px;
    font-size: 48px;
    border-radius: 0;
    background: transparent;
    border: none;
    margin: 0 auto;
    flex-shrink: 0;
  }

  .btn-icon i {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    line-height: 1;
  }

  .btn-content {
    flex: 0 0 auto;
    width: 100%;
    align-items: center;
    text-align: center;
    gap: 4px;
  }

  .btn-name {
    font-size: 13px;
    line-height: 1.3;
  }

  .btn-label {
    font-size: 10px;
  }

  .footer {
    max-width: 820px;
    margin-top: 32px;
    padding-top: 28px;
  }

  .license-img {
    max-width: 180px;
  }
}

@media (min-width: 1100px) {
  .container,
  .footer {
    max-width: 960px;
  }

  .social-grid {
    gap: 20px;
  }

  .btn-icon {
    min-width: 88px;
    min-height: 88px;
    font-size: 54px;
  }

  .btn-name {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .linktree {
    padding: 76px 12px 24px;
  }

  .top-nav {
    min-height: 60px;
    padding: 10px 12px;
    gap: 10px;
  }

  .nav-logo-link,
  .nav-brand {
    height: 34px;
    min-height: 34px;
    max-width: calc(100% - 108px);
  }

  .nav-logo {
    max-height: 34px;
    max-width: 118px;
  }

  .nav-brand {
    font-size: 14px;
  }

  .nav-cta {
    min-height: 34px;
    padding: 8px 14px;
    font-size: 12px;
  }

  .section-title {
    font-size: clamp(20px, 7vw, 28px);
  }

  .social-btn {
    max-width: 100%;
  }

  .btn-icon {
    width: 54px;
    height: 54px;
    min-width: 54px;
    min-height: 54px;
    font-size: 26px;
  }

  .btn-name {
    font-size: 14px;
  }
}

@media (max-width: 360px) {
  .social-btn {
    padding: 12px 14px;
    gap: 12px;
  }

  .btn-icon {
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    font-size: 24px;
  }
}
</style>
